import { useQuery } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const fetchWorkflowRequiredPermissions = (id) => AIAgentDefinitions.getRequiredPermissions(id).then(({ permissions }) => permissions);
const useWorkflowRequiredPermissions = (id) => useQuery({
  queryKey: [...WORKFLOW_DEFINITIONS_QUERY_KEY, "permissions", id],
  queryFn: () => fetchWorkflowRequiredPermissions(id),
  enabled: Boolean(id),
  staleTime: 6e4
});
export default useWorkflowRequiredPermissions;
